import script from "./CreateUpdateOcupacoesSolo.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateOcupacoesSolo.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateOcupacoesSolo.vue?vue&type=style&index=0&id=95aa4536&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95aa4536"]])

export default __exports__